"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useAddConceptOfferHintError = void 0;
var _showErrorNotification = require("@ori-events/show-error-notification");
var _logger = require("@ori/logger");
var _react = require("react");
var _contexts = require("../contexts");
var _logger2 = require("../logger");
var _utils = require("../utils");
var _useTimeout = require("./useTimeout");
/**
 * Failed apply offer response callback definition for ConceptOfferHint.
 * Displays error for the user via triggerng show-error-notification custom event.
 * Optionally filters out unfulfillable offer from the displayed list.
 * This state change is applied after same delay as the display duration
 * of error notification. It is done via setTimeout.
 */ const useAddConceptOfferHintError = (param)=>{
    let { isOfferApplicable, offerId, setAvailability, setOfferItems } = param;
    const logger = (0, _logger.useLogger)('useAddConceptOfferHintError');
    const { setNotAvailableOfferIds } = (0, _contexts.useCheckoutOfferHints)();
    const offerRemovalTimeout = (0, _useTimeout.useTimeout)({
        callback: ()=>setNotAvailableOfferIds((existingNotAvailableOfferIds)=>existingNotAvailableOfferIds.includes(offerId) ? existingNotAvailableOfferIds : [
                    ...existingNotAvailableOfferIds,
                    offerId
                ]),
        delay: _utils.errorNotificationTimeOut,
        shouldClearOnUnmount: false
    });
    const showError = (0, _react.useCallback)((isStillApplicable, serverError)=>{
        let message;
        if (isStillApplicable) {
            message = (0, _utils.getErrorTranslationId)(serverError !== null && serverError !== void 0 ? serverError : '');
        } else {
            message = _showErrorNotification.translationKeys.offerIsNotAvailable;
        }
        (0, _utils.showErrorNotification)(message);
    }, []);
    const onAddOfferFailedCallback = (0, _react.useCallback)((response, otherError)=>{
        if (response) {
            // availability info is present only when there were OOS products
            // or insufficient on-stock quantities
            const { availability = [], message } = response;
            const isStillApplicable = isOfferApplicable(availability);
            if (isStillApplicable) {
                // reduce selections according to availability info
                setAvailability(availability);
                (0, _logger2.logDebug)("Selections for offer ".concat(offerId, " were updated."));
            } else {
                // selections for current offer should be reset
                setOfferItems((items)=>items.map((item)=>({
                            ...item,
                            selectedQuantity: 0
                        })));
                // after specific time amount, the offer will be removed from the list
                offerRemovalTimeout.set();
                (0, _logger2.logDebug)("Offer ".concat(offerId, " can't be applied. Offer removal is scheduled."));
            }
            // show specific error, the duration of displaying this
            // is synchronized with the offer removal delay
            showError(isStillApplicable, message);
        } else {
            // in other cases just display the generic error
            (0, _utils.showErrorNotification)();
            const error = new Error('Error while adding basket offer');
            logger.error(error, {
                otherError: String(otherError)
            });
        }
    }, [
        isOfferApplicable,
        logger,
        offerId,
        offerRemovalTimeout,
        setAvailability,
        setOfferItems,
        showError
    ]);
    return onAddOfferFailedCallback;
};
exports.useAddConceptOfferHintError = useAddConceptOfferHintError;
